import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ProductCard from '../components/ProductCard';
import { fetchProducts } from '../services/api';
import { products as mockProducts } from '../mockData';
import { Toaster } from '../components/ui/toaster';

const Lifestyle = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const data = await fetchProducts('lifestyle', 100);
        setProducts(data);
      } catch (error) {
        setProducts(mockProducts.filter(p => p.category === 'engagement').slice(0, 12));
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-light text-gray-800 mb-4">Lifestyle Jewelry</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Everyday pieces designed for self-expression. Necklaces, earrings, bracelets, and more - all ethically made.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12">
        {loading ? (
          <div className="text-center py-20">
            <div className="w-16 h-16 border-4 border-gray-300 border-t-gray-800 rounded-full animate-spin mx-auto mb-4"></div>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </div>

      <Footer />
      <Toaster />
    </div>
  );
};

export default Lifestyle;